// extracted by mini-css-extract-plugin
export default {"questionContainer":"styles_questionContainer__6s9mj","questionIcon":"styles_questionIcon__H-Ks+","questionText":"styles_questionText__7DVYd"};